module.exports = __webpack_public_path__ + "img/flowIcon.27a09568.svg";